import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ExpenseComponent } from './components/expense/expense.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxDatatableModule
  ],
  declarations: [
    ExpenseComponent
  ]
})
export class ExpenseModule { }



// WEBPACK FOOTER //
// ./src/app/expense/expense.module.ts